import { gql, useMutation } from "@apollo/client";

import { CreateCategoryInput } from "../../../generated/gql/graphql";

const CREATE_CATEGORY = gql`
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      id
      name
      parentId
      orderIndex
    }
  }
`;

type CreateCategoryApi = {
  createCategory(input: CreateCategoryInput): Promise<unknown>;
};

export default function useCreateCategory(): CreateCategoryApi {
  const [createNewCategory] = useMutation<CreateCategoryInput>(CREATE_CATEGORY);

  async function createCategory(input: CreateCategoryInput): Promise<unknown> {
    return await createNewCategory({
      context: {
        headers: {
          "apollo-require-preflight": true,
        },
      },
      variables: {
        input,
      },
    });
  }

  return {
    createCategory,
  };
}
